export function characterToHTMLEntity(stringVal) {
  let resultString = stringVal;
  if (resultString && resultString.includes('’')) {
    resultString = resultString.replace(/’/g, '&rsquo;');
  }
  return resultString;
}
